import React, { useState, useEffect, useCallback, forwardRef, useRef } from "react";
import { IconButton, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@mui/material";
import moment from "moment";
import AximTooltip from "components/AximTooltip";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import ChangeEmployeeBenefits from "area/employer/EmployeeCensus/ChangeEmployeeBenefits";
import ViewEmployeeBenefitsHistory from "area/employer/EmployeeCensus/ViewEmployeeBenefitsHistory";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import * as Yup from 'yup';

import { Utils } from "common/Utils";
const viewDataOnly = false
const EmployeeBenefits = forwardRef(({ fetchedData, employee, handleSaveEmployeeBenefit }, ref) => {
  const [openViewBenefitsModal, setViewOpenBenefitsModal] = useState(false);
  const [openEditBenefitsModal, setEditOpenBenefitsModal] = useState(false);
  const [fetchedEditBenefitsData, setFetchedEditBenefitsData] = useState({});
  const [fetchedEnrollmentHistory, setFetchedEnrollmentHistory] = useState({});

  const editBenefitsRef = useRef({});
  const [benefitErrors, setBenefitErrors] = useState({});
  const [formData, setFormData] = useState(fetchedData);


  const benefitValidationSchema = Yup.object().shape({
    coverageLevelID: Yup.string().required('Coverage is required'),
    startDate: Yup.date().min('1901-01-01').typeError('Start date is required')
  });

  const handleEditBenefitClose = () => {
    setEditOpenBenefitsModal(false)
  }

  const handleViewBenefitClose = () => {
    setViewOpenBenefitsModal(false)
  }

  const handleEditBenefitSave = async () => {
    console.log('in handleEditBenefitSave')
    console.log(editBenefitsRef, 'editBenefitsRef')
    console.log(editBenefitsRef.current.formData, 'editBenefitsRef')
    if (editBenefitsRef != null && editBenefitsRef.current.formData !== undefined) {
      let editFormData = editBenefitsRef.current.formData;

      try {
        const valid = await benefitValidationSchema.validateSync(editFormData,
          { abortEarly: false }
        );
        console.log(valid, 'valid')

        editFormData["updated"] = true;
        console.log(editFormData, 'handleEditBenefitSave')
        console.log(formData, 'existing form data')
        let newFormData = formData.map((obj => obj.benefitID == editFormData.benefitID ?
          { ...obj, ...editFormData } : obj))
        console.log(newFormData)

        if (editBenefitsRef?.current) {
          editBenefitsRef.current.formData = newFormData
        }
        setFormData(newFormData)
        handleSaveEmployeeBenefit(newFormData)
        setEditOpenBenefitsModal(false)

      } catch (error) {
        // error.inner
        console.log(error, 'valid error')
        console.log(error.inner, 'valid error inner')
        let pErrors = {};
        for (const err of error.inner) {
          if (err.path) {
            console.log(err.path, 'err.path')
            console.log(err.message, 'err.message')
            Object.defineProperty(pErrors, err.path, {
              value: err.message,
              writable: true
            });
            //pErrors[error.path] = error.message;
          }
        }

        console.log(pErrors, 'pErrors')
        setBenefitErrors(pErrors)
      }

      /*
      let updatedValue = {[name]:val};
      if (ref?.current) {
        ref.current.formData = {
          ...formData,
          ...updatedValue
        };
      }
      setFormData(formData => ({
        ...formData,
        ...updatedValue
      }));
      */
    }
  }
  const handleViewEmployeeBenefit = (enrollment) => {
    console.log(enrollment)


    apiGet(apiUrls.getEnrollmentHistory(enrollment.insuredID, enrollment.benefitTypeID, enrollment.planPeriodID)).then(
      (empResponse) => {
        console.dir('emp enrollments history response');
        console.dir(empResponse);
        setFetchedEnrollmentHistory(empResponse)
        setViewOpenBenefitsModal(true)
      });
  }

  const handleEditEmployeeBenefit = (enrollment) => {
    setFetchedEditBenefitsData(enrollment)
    setEditOpenBenefitsModal(true)
  }

  const handleChange = useCallback(
    (name, val) => {
      let updatedValue = { [name]: val };
      if (ref?.current) {
        ref.current.formData = {
          ...formData,
          ...updatedValue
        };
      }
      setFormData(formData => ({
        ...formData,
        ...updatedValue
      }));
    },
    [ref]
  );
  return (
    <>
      <table className="table tableall--wrapper ">
        <thead>
          <tr>
            <th role="columnheader"></th>
            <th role="columnheader">Benefit</th>
            <th role="columnheader">Benefit Type</th>
            <th role="columnheader">Start Date</th>
            <th role="columnheader">End Date</th>
            <th role="columnheader">Coverage</th>
            <th role="columnheader">Carrier</th>
          </tr>
        </thead>
        <tbody>
          {formData.map((val, i) => (<tr>
            <td>
              <AximTooltip title="Edit">
                <IconButton color="primary"
                  onClick={(e) => handleEditEmployeeBenefit(val)}>
                  <EditOutlinedIcon />
                </IconButton>
              </AximTooltip>
              <AximTooltip title="View">
                <IconButton color="primary"
                  onClick={(e) => handleViewEmployeeBenefit(val)}>
                  <VisibilityOutlinedIcon />
                </IconButton>
              </AximTooltip>
            </td>
            <td>{val.benefit}</td>
            <td>{val.benefitType}</td>
            <td>{Utils.formatDate(val.startDate)}</td>
            <td>{Utils.formatDate(val.endDate)}</td>
            <td>{val.coverage}</td>
            <td>{val.carrier}</td>
          </tr>))}
        </tbody>
      </table>


      {/* Update Benefits Modal */}
      <Dialog
        open={openEditBenefitsModal}
        onClose={handleEditBenefitClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={ModalStyles.empDataModal}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          Update Employee Benefits
        </DialogTitle>
        <DialogContent className={ModalStyles.CustomTabsWrapper}>

          {fetchedEditBenefitsData !== undefined ? (
            <form noValidate autoComplete="off" className="grid">
              <ChangeEmployeeBenefits fetchedData={fetchedEditBenefitsData} ref={editBenefitsRef} employee={employee} errors={benefitErrors}></ChangeEmployeeBenefits>
            </form>
          ) : (
            <h3>No Data Available</h3>
          )}
        </DialogContent>
        <DialogActions className={ButtonStyle.buttonWrapper}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleEditBenefitSave}
            className={ButtonStyle.CcancelBtn}
          >
            Save
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleEditBenefitClose}
            className={ButtonStyle.CcancelBtn}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Update Benefits Modal */}
      <Dialog
        open={openViewBenefitsModal}
        onClose={handleViewBenefitClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={ModalStyles.empDataModal}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          View Employee Enrollment History
        </DialogTitle>
        <DialogContent className={ModalStyles.CustomTabsWrapper}>

          {fetchedEnrollmentHistory !== undefined ? (
            <form noValidate autoComplete="off" className="grid">
              <ViewEmployeeBenefitsHistory fetchedData={fetchedEnrollmentHistory} ref={editBenefitsRef} employee={employee} errors={benefitErrors}></ViewEmployeeBenefitsHistory>
            </form>
          ) : (
            <h3>No Data Available</h3>
          )}
        </DialogContent>
        <DialogActions className={ButtonStyle.buttonWrapper}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleViewBenefitClose}
            className={ButtonStyle.CcancelBtn}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
});

export default EmployeeBenefits;